import { render, staticRenderFns } from "./TraxUiUserCard.vue?vue&type=template&id=09e3fa81"
import script from "./TraxUiUserCard.vue?vue&type=script&lang=js"
export * from "./TraxUiUserCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports